import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {
  hasSignupRoleSelected,
  isSignupVerified,
} from "../store/signupStorage";

// Hook to check if user is authenticated
export const useAuth = () => {
  try {
    const stored = localStorage.getItem("loggedInUser");
    if (!stored) return { isAuthenticated: false, user: null };

    const user = JSON.parse(stored);

    return {
      isAuthenticated: !!user,
      user,
    };
  } catch {
    return {
      isAuthenticated: false,
      user: null,
    };
  }
};

export const PublicRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    if (user?.role === "student") {
      return <Navigate to="/student" replace />;
    }

    if (user?.role === "instructor") {
      return <Navigate to="/instructor/dashboard" replace />;
    }

    return <Navigate to="/" replace />;
  }

  return children;
};

export const SignupProfileRoute = ({ children, role }) => {
  if (!hasSignupRoleSelected(role) && !isSignupVerified()) {
    return <Navigate to="/signup" replace />;
  }

  return children;
};

export const ProtectedRoute = ({ children, role }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role && user?.role !== role) {
    return <Navigate to="/login" replace />;
  }

  // Supports both nested routes and wrapped children
  return children || <Outlet />;
};

export default useAuth;